import React from 'react';
import PropTypes from 'prop-types';
import './MFASuccessModal.css';
import closeIcon from "../../assets/images/mfa/close-icon.svg";

const MFASuccessModal = ({ isOpen, onClose, onLogin }) => {
    if (!isOpen) return null;

    return (
        <div className="mfa-modal-overlay">
            <div className="mfa-modal-content">
                <div className="mfa-modal-header">
                    <h2 className="mfa-modal-title">Configuration Success</h2>
                    <button className="mfa-modal-close-btn" onClick={onClose}>
                        <img src={closeIcon} alt="close" className='close-icon-img' />
                    </button>
                </div>
                <div className="mfa-modal-body">
                    <p className="mfa-modal-text">
                        Your Multi-factor authentication has been <strong>Enabled</strong>
                    </p>
                    <p className="mfa-modal-text">You will need to login again.</p>
                </div>
                <div className="mfa-modal-footer">
                    <button className="mfa-login-btn" onClick={onLogin}>
                        Login
                    </button>
                </div>
            </div>
        </div>
    );
};

MFASuccessModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
};

export default MFASuccessModal;